<template>
<div class="catalog-filters">
  <slot name="before"/>
  <FilterWrapper
    v-for="feature in features"
    :key="feature.id"
    :name="feature.name"
    :expanded="!collapsedFilters.includes(feature.id)"
    @click:toggle="toggleFilterCollapsed(feature.id)"
    :show-clear-button="activeFilters.includes(feature.id)"
    @click:clear="$emit('update', feature.id, (emptyValues[feature.field_type.id] || emptyValues.default).create())"
  >
    <component
      v-if="!collapsedFilters.includes(feature.id)"
      :is="getFeatureFilterComponent(feature)"
      :feature="feature"
      :value="value[feature.id]"
      @input="$emit('update', feature.id, $event)"
    />
  </FilterWrapper>
  <button
    @click="$emit('click:apply')"
    class="catalog-filters__apply-filters-button btn btn-primary btn-rounded"
    type="button"
  >Применить фильтр</button>
  <button
    @click="$emit('click:reset')"
    class="catalog-filters__reset-filters-button btn btn-primary-outline btn-rounded"
    type="button"
  >Сбросить</button>
</div>
</template>

<script>
import FilterWrapper from './filters/FilterWrapper';

const checkboxes = () => import('./filters/CheckboxesFeatureField');
const filterComponentsMap = {
  checkboxes,
  multiple_select: () => import('./filters/MultipleSelectFeatureField'),
  range: () => import('./filters/RangeFeatureField'),
  select: () => import('./filters/SelectFeatureField'),
  radios: () => import('./filters/RadioFeatureField'),
  default: checkboxes,
};

export default {
  components: {
    FilterWrapper,
  },
  props: {
    value: {
      required: true,
      type: Object,
    },
    features: {
      required: true,
      type: Array,
    },
    emptyValues: {
      required: true,
      type: Object,
      validator: v => v.default.isEmpty instanceof Function && v.default.create instanceof Function,
    },
  },
  methods: {
    toggleFilterCollapsed(featureId) {
      const ind = this.collapsedFilters.indexOf(featureId);
      ind >= 0 ? this.collapsedFilters.splice(ind, 1) : this.collapsedFilters.push(featureId);
    },

    getFeatureFilterComponent(feature) {
      return filterComponentsMap[feature.field_type.id]
        || filterComponentsMap.default;
    },
  },
  computed: {
    activeFilters() {
      return Object.entries(this.value)
        .filter(([id, val]) => {
          const feature = this.features.find(f => f.id === id);
          return !(this.emptyValues[feature.field_type.id] || this.emptyValues.default).isEmpty(val);
        })
        .map(([id, _]) => id);
    },
  },
  data() {
    return {
      collapsedFilters: [],
    };
  },
};
</script>

<style lang="less">
.catalog-filters {
  @apply px-5;
  // `.btn` to override `.btn`'s `display: inline-block;`
  &__apply-filters-button.btn,
  &__reset-filters-button.btn {
    @apply my-2 block text-sm w-full;
    &:last-of-type {
      @apply mb-4;
    }
  }
}
</style>
